export function changeUrl(url) {

    try {
        window.history.pushState("", "", url);
    } catch (error) {

    }

}

export function changeTitle(title) {
    try {
        document.title = title
    } catch (error) {

    }
}

export function changeUrlForMember(member) {

    let url = member.member_post_name;
    let title = member.member_seo_title;

    // Check if member data exists
    if (!member || !url) {
        console.warn('Invalid member data for URL change');
        return;
    }

    // Check if title exists or is valid
    if (!title || title.length <= 1) {
        title = member.member_post_title || 'Member';
    }

    if (url.charAt(0) !== '/') {
        url = '/' + url;
    }

    url = '/listing' + url;

    changeUrl(url);
    changeTitle(title);

}
